export default __webpack_public_path__ + "static/media/logo.3074f666.png";